export default function SciPy_Editor() {
  return (
    <div>
      <h1>SciPy Editor</h1>
    </div>
  );
}
